module.exports = __webpack_public_path__ + "img/mid-ad.30fd812e.png";